// extracted by mini-css-extract-plugin
export default {"color":"icon-by-type_color__QX8HX","placeHolderShimmer":"icon-by-type_placeHolderShimmer__Y1vVB"};